import React, { useId } from 'react';

export function PointingArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="107" height="35" viewBox="0 0 107 35" fill="none" {...props}>
      <path
        d="M1 27.2661C16.7695 28.2353 30.311 24.9451 39.3177 11.1566C42.3496 6.51503 43.5764 -1.23127 35.0602 1.6103C27.1492 4.24991 22.9187 15.9962 25.9917 23.5157C30.6031 34.8 44.0773 35.3579 54.4745 32.6359C70.56 28.4247 86.2996 22.8313 100.626 14.3956C103.544 12.6773 82.509 8.99914 89.5139 11.1566C94.4582 12.6794 98.9618 12.6909 104.075 12.6909C107.756 12.6909 105.402 13.9267 103.266 15.7593C99.7945 18.7376 96.3821 23.5469 95.2615 28.0332"
        stroke="#E1E4EA"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function NovuLogo() {
  const gradientId = useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="328" height="232" viewBox="0 0 328 232" fill="none">
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M190 24C128 24 77.7 74.3 77.7 136.3V197.9L50.5 252.3C43 267.2 53.8 285.2 70.4 285.2H309.6C326.2 285.2 337 267.2 329.5 252.3L302.3 197.9V136.3C302.3 74.3 252 24 190 24ZM148.6 309.5C151.6 329.5 169 344.8 190 344.8C211 344.8 228.4 329.5 231.4 309.5H148.6Z"
          fill={`url(#${gradientId})`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M190 24C128 24 77.7 74.3 77.7 136.3V197.9L50.5 252.3C43 267.2 53.8 285.2 70.4 285.2H309.6C326.2 285.2 337 267.2 329.5 252.3L302.3 197.9V136.3C302.3 74.3 252 24 190 24ZM148.6 309.5C151.6 329.5 169 344.8 190 344.8C211 344.8 228.4 329.5 231.4 309.5H148.6Z"
          fill="#F0F0F0"
          fillOpacity="0.15"
        />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="4.92032" y1="68.506" x2="158.207" y2="160.1" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EEEEEE" stopOpacity="0" />
          <stop offset="1" stopColor="#F9F9F9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
